import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
import { TENANTID } from '@/store/mutation-types'

import homePage from '@/views/home'
import productPage from '@/views/product'
import proDetailPage from '@/views/product/detail'
import cartPage from '@/views/cart'
import orderPage from '@/views/order'
import orderDetailPage from '@/views/order/detail'
import aboutPage from '@/views/about/index'
import contactPage from '@/views/about/contact'
import addressPage from "../views/address"
import news from "@/views/news"
import newsDetail from "@/views/news/detail"
import video from "@/views/video"
import auditaccount from "@/views/audit" // 国安审核账号页面
import newPro from "@/views/newPro"
import brand from "@/views/brand"
import recommendPro from "@/views/recommendPro"


Vue.use(VueRouter)
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
let pathName = '/home'

const routes = [
    {
        path: '/',
        redirect: pathName
    }, {
        name: 'home',
        path: '/home',
        component: homePage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'product',
        path: '/product',
        component: productPage,
        meta: {
            keepAlive: false // 开启缓存
        }
    },
    {
        name: 'proDetail',
        path: '/proDetail',
        component: proDetailPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'cart',
        path: '/cart',
        component: cartPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'order',
        path: '/order',
        component: orderPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'address',
        path: '/address',
        component: addressPage,
        meta: {
            keepAlive: false
        }
    },

    {
        name: 'orderDetail',
        path: '/order/detail',
        component: orderDetailPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'about',
        path: '/about',
        component: aboutPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'contact',
        path: '/contact',
        component: contactPage,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'news',
        path: '/news',
        component: news,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'newsDetail',
        path: '/newsDetail',
        component: newsDetail,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'video',
        path: '/video',
        component: video,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'auditaccount',
        path: '/auditaccount',
        component: auditaccount,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'newPro',
        path: '/newPro',
        component: newPro,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'brand',
        path: '/brand',
        component: brand,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'recommendPro',
        path: '/recommendPro',
        component: recommendPro,
        meta: {
            keepAlive: false
        }
    },
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    let obj = store.state.user
    next()
})

export default router